import { Action, createReducer, on } from '@ngrx/store';
import { GetFirstContactForAccountState } from './get-first-contact-for-account.types';
import { getFirstContactForAccountAction, getFirstContactForAccountFailureAction, getFirstContactForAccountSuccessAction } from './get-first-contact-for-account.actions';

const initialState = {
  loading: false,
  loaded: false,
  data: undefined,
  error: null,
};

const getFirstContactForAccountReducer = createReducer<GetFirstContactForAccountState>(
  initialState,
  on(
    getFirstContactForAccountAction,
    state => ({
      ...state,
      loading: true,
      loaded: false,
      data: undefined,
    })
  ),
  on(
    getFirstContactForAccountSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      data: action.data,
      error: undefined,
    })
  ),
  on(
    getFirstContactForAccountFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetFirstContactForAccountState, action: Action) => getFirstContactForAccountReducer(state, action);
